import React from 'react'
import {
    Button, Container,
    Row, Col, Label, Input,
    Table,
} from 'reactstrap'
import {
    getLatest,
} from '../model/request/machine'
import dateFormat from 'dateformat'
import SimpleDropdown from '../view/DropDownView'

const Images = [
  {
    'label': 'Select One',
    'src': null,
  },
  {
    'label': 'Expected Time',
    'src': 'https://comosum-statistics-images.s3.us-east-2.amazonaws.com/plot1.png',
  },
  {
    'label': 'Correlation 1',
    'src': 'https://comosum-statistics-images.s3.us-east-2.amazonaws.com/plot2.png',
  },
  {
    'label': 'Correlation 2',
    'src': 'https://comosum-statistics-images.s3.us-east-2.amazonaws.com/plot3.png',
  },
  {
    'label': 'Temperature Over Time',
    'src': 'https://comosum-statistics-images.s3.us-east-2.amazonaws.com/plot4.png',
  },
  {
    'label': 'Plate Accuracy',
    'src': 'https://comosum-statistics-images.s3.us-east-2.amazonaws.com/plot5.png',
  }
]

class MachineChartsViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
          'index': 0
        }
    }

    labelAndValue(label, value) {
      return <Col><Container>
        <Row><Col><Label>{label}</Label></Col></Row>
        <Row><Col><Label>{value}</Label></Col></Row>
      </Container></Col>
    }

    render() {
        return (
            <Container>
              <Row><Col><Label
                style={{
                  'fontSize': '20pt',
                  'fontWeight': '400',
                }}
              >Charts</Label></Col></Row>
              <Row>
                  {this.labelAndValue(
                    'Select One',
                <SimpleDropdown
                    size="sm"
                    index={this.state.index}
                    values={Images.map((img) => img.label)}
                    onChange={(i) => {
                      this.setState({
                        'index': i
                      })
                    }} />
                  )}
              </Row>
              <Row><Col>
                {this.state.index > 0 ? <img
                  style={{
                    'maxWidth': '95%',
                    'maxHeight': '95%',
                  }}
                  src={Images[this.state.index].src} /> :<></>}
              </Col></Row>
            </Container>
        )
    }
}

export default MachineChartsViewController

